export const useSelectionFilterBuilder = () => {
  const buildFilter = ({
    filterId,
    projectId,
    conjunction,
    entity,
    predicates = []
  }) => {
    const predicateList = [...predicates]

    if (filterId) {
      predicateList.push({
        attribute: 'Filter',
        operator: 'Is',
        values: [filterId]
      })
    }

    return { conjunction, entity, projectId, predicates: predicateList }
  }

  const buildEntityFilter = ({
    items,
    attribute,
    operator,
    entity,
    conjunction,
    filterId,
    projectId,
    predicates = []
  }) => {
    const basePredicates = [...predicates]

    if (items?.length > 0) {
      basePredicates.push({ attribute, operator, values: items })
    }

    return buildFilter({
      filterId,
      projectId,
      conjunction,
      entity,
      predicates: basePredicates
    })
  }

  const buildSelectedPinsFilter = ({
    selectedPins,
    filterId,
    projectId,
    predicates = []
  }) =>
    buildEntityFilter({
      items: selectedPins,
      attribute: 'PinUUID',
      operator: 'Any',
      entity: 'Pins',
      conjunction: 'All',
      predicates,
      filterId,
      projectId
    })

  const buildSelectedAllPinsFilter = ({
    notSelectedPins,
    filterId,
    projectId,
    predicates = []
  }) =>
    buildEntityFilter({
      items: notSelectedPins,
      attribute: 'PinUUID',
      operator: 'None',
      entity: 'Pins',
      conjunction: 'All',
      predicates,
      filterId,
      projectId
    })

  const buildSelectedTasksFilter = ({
    selectedTasks,
    filterId,
    projectId,
    predicates = []
  }) =>
    buildEntityFilter({
      items: selectedTasks,
      attribute: 'TaskUUID',
      operator: 'Any',
      entity: 'Tasks',
      conjunction: 'All',
      predicates,
      filterId,
      projectId
    })

  const buildSelectedAllTasksFilter = ({
    notSelectedTasks,
    filterId,
    projectId,
    predicates = []
  }) =>
    buildEntityFilter({
      items: notSelectedTasks,
      attribute: 'TaskUUID',
      operator: 'None',
      entity: 'Tasks',
      conjunction: 'All',
      predicates,
      filterId,
      projectId
    })

  return {
    buildSelectedPinsFilter,
    buildSelectedAllPinsFilter,
    buildSelectedTasksFilter,
    buildSelectedAllTasksFilter
  }
}
